import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getIndividualCustomerService from 'services/individualCustomers';
import getAreasListService, { getDepartmentsByAreaService, getSpecialistsByDepartmentService } from 'services/individualCustomers/areasList';
import { AreasListTypes, DepartmentsByAreaTypes, SpecialistsByDepartmentTypes } from 'services/individualCustomers/areasList/type';
import { IndividualCustomerServiceDataTypes } from 'services/individualCustomers/types';

interface ServiceIndividual {
  data: IndividualCustomerServiceDataTypes[];
  areasList: AreasListTypes[];
  departmentsByArea: DepartmentsByAreaTypes[];
  specialistsByDepartment: SpecialistsByDepartmentTypes[];
}

const initialState: ServiceIndividual = {
  data: [],
  areasList: [],
  departmentsByArea: [],
  specialistsByDepartment: [],
};

export const getIndividualCustomerAction = createAsyncThunk<
  IndividualCustomerServiceDataTypes[],
  void,
  { rejectValue: ErrorResponse }
>('individualCustomerReducer/getServiceIndividualList', async (_, { rejectWithValue }) => {
  try {
    return await getIndividualCustomerService();
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});
/**
 * Get Area list
 */
export const getAreasListAction = createAsyncThunk<
 AreasListTypes[],
 void,
 { rejectValue: ErrorResponse }
>('individualCustomerReducer/getAreasListAction', async (_, { rejectWithValue }) => {
  try {
    return await getAreasListService();
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

/**
* Get Departments by area list
*/
export const getDepartmentsByAreaAction = createAsyncThunk<
 DepartmentsByAreaTypes[],
 number,
 { rejectValue: ErrorResponse }
>('individualCustomerReducer/getDepartmentsByAreaAction', async (id: number, { rejectWithValue }) => {
  try {
    return await getDepartmentsByAreaService(id);
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

/**
* Get specialists by department
*/
export const getSpecialistsByDepartmentAction = createAsyncThunk<
 SpecialistsByDepartmentTypes[],
 number,
 { rejectValue: ErrorResponse }
>('individualCustomerReducer/getSpecialistsByDepartmentAction', async (id: number, { rejectWithValue }) => {
  try {
    return await getSpecialistsByDepartmentService(id);
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

export const IndividualCustomerSlice = createSlice({
  name: 'individualCustomerReducer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getIndividualCustomerAction.fulfilled, ($state, action) => {
      $state.data = action.payload;
    });
    builder.addCase(getAreasListAction.fulfilled, ($state, action) => {
      $state.areasList = action.payload;
    });
    builder.addCase(getDepartmentsByAreaAction.fulfilled, ($state, action) => {
      $state.departmentsByArea = action.payload;
    });
    builder.addCase(getSpecialistsByDepartmentAction.fulfilled, ($state, action) => {
      $state.specialistsByDepartment = action.payload;
    });
  },
});

export default IndividualCustomerSlice.reducer;
